// extracted by mini-css-extract-plugin
export default {"container":"_7icIL","back-office":"sELtM","backOffice":"sELtM","success":"a8i2m","error":"TMRZB","info":"-5fQy","center":"dxLTs","static":"m-Tvb","close":"vUb-F"};